import { render, staticRenderFns } from "./commodity-market.vue?vue&type=template&id=5d43f0b6&scoped=true&"
import script from "./commodity-market.vue?vue&type=script&lang=js&"
export * from "./commodity-market.vue?vue&type=script&lang=js&"
import style0 from "./commodity-market.vue?vue&type=style&index=0&id=5d43f0b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d43f0b6",
  null
  
)

export default component.exports